import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";

import Scroll from "./components/Scroll";
import WhatsAppIcon from "./components/WhatsAppIcon";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import HomePage from "./pages/HomePage";
import ProductosPage from "./pages/ProductosPage";
import NosotrosPage from "./pages/NosotrosPage";
import ContactoPage from "./pages/ContactoPage";

function App() {
  return (
    <Router>
      <WhatsAppIcon />
      <Scroll />
      <Navbar />

      <Box>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/productos" element={<ProductosPage />} />
          <Route path="/nosotros" element={<NosotrosPage />} />
          <Route path="/contacto" element={<ContactoPage />} />
          {/* <Route path="/tienda" element={<TiendaPage />} /> */}
        </Routes>
      </Box>

      <Footer />
    </Router>
  );
}

export default App;
